/**
 * Événement generate_lead — toujours actif (GTM + sstrac sans consentement).
 * Défini dans ewigo-analytics-lead.js (inline head) + appel Vue via ewigoTrackGenerateLead.
 */
export function trackGenerateLead() {
    globalThis.ewigoTrackGenerateLead?.();
}
